import React from 'react';

const CreateInvoice = () => {
  return (
    <div className="card p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        Create Invoice
      </h1>
      <p className="text-gray-600 dark:text-gray-400">
        Invoice creation functionality will be implemented here.
      </p>
    </div>
  );
};

export default CreateInvoice;
